import { slug } from "../shared/config";

async function pullData() {
  const response = await fetch(
    "https://kerckhoff.dailybruin.com/api/packages/flatpages/" + slug
  );
  const json = await response.json();
  const { data } = json;
  return data;
}

export default pullData();
